import Pagination from './Pagination.jsx';
import NextButton from './NextButton.jsx';
import PreviousButton from './PreviousButton.jsx';
import ScrollContainer from './ScrollContainer.jsx';


export default {
  Pagination,
  NextButton,
  PreviousButton,
  ScrollContainer
};

